import React from 'react'

interface MiniWaveChartProps {
  className?: string
}

/**
 * Data Plot chart for Total Funding Rounds card (second card in Figma)
 * Simple semi-circle arc like Market Indicator - node-id 37:760
 */
export const MiniWaveChart: React.FC<MiniWaveChartProps> = ({ className }) => {
  // Center and radius for the arc
  const centerX = 92.5
  const centerY = 185
  const radius = 140
  const arcWidth = 30
  
  // Calculate arc path (180 degrees, from left to right)
  const startAngle = Math.PI // 180 degrees
  const endAngle = 0 // 0 degrees
  
  // Calculate outer arc points
  const outerStartX = centerX + radius * Math.cos(startAngle)
  const outerStartY = centerY + radius * Math.sin(startAngle)
  const outerEndX = centerX + radius * Math.cos(endAngle)
  const outerEndY = centerY + radius * Math.sin(endAngle)
  
  // Calculate inner arc points
  const innerRadius = radius - arcWidth
  const innerStartX = centerX + innerRadius * Math.cos(startAngle)
  const innerStartY = centerY + innerRadius * Math.sin(startAngle)
  const innerEndX = centerX + innerRadius * Math.cos(endAngle)
  const innerEndY = centerY + innerRadius * Math.sin(endAngle)
  
  return (
    <div className={`absolute h-[124px] overflow-clip right-0 top-0 w-[185px] ${className || ''}`}>
      <div className="absolute left-0 size-[185px] top-[48px]">
        <svg
          className="w-full h-full"
          viewBox="0 0 185 185"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            {/* Gradient for the arc - yellow-green like #C4E804 */}
            <linearGradient id="arcGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="rgba(196,232,4,0.3)" />
              <stop offset="30%" stopColor="rgba(196,232,4,0.6)" />
              <stop offset="100%" stopColor="rgba(196,232,4,0.9)" />
            </linearGradient>
          </defs>
          
          {/* Background arc (light gray) */}
          <path
            d={`M ${outerStartX} ${outerStartY} A ${radius} ${radius} 0 0 1 ${outerEndX} ${outerEndY} L ${innerEndX} ${innerEndY} A ${innerRadius} ${innerRadius} 0 0 0 ${innerStartX} ${innerStartY} Z`}
            fill="rgba(229,229,229,0.3)"
            className="dark:fill-[rgba(255,255,255,0.1)]"
          />
          
          {/* Active arc (yellow-green gradient) - partial fill, like 30% */}
          <path
            d={`M ${outerStartX} ${outerStartY} A ${radius} ${radius} 0 0 1 ${centerX + radius * Math.cos(startAngle + Math.PI * 0.3)} ${centerY + radius * Math.sin(startAngle + Math.PI * 0.3)} L ${centerX + innerRadius * Math.cos(startAngle + Math.PI * 0.3)} ${centerY + innerRadius * Math.sin(startAngle + Math.PI * 0.3)} A ${innerRadius} ${innerRadius} 0 0 0 ${innerStartX} ${innerStartY} Z`}
            fill="url(#arcGradient)"
          />
        </svg>
      </div>
    </div>
  )
}

export default MiniWaveChart
